import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../utils/auth/Auth'

export const LayoutNotLogged: React.FC = () => {
  const { isLogged } = useAuth()

  if (isLogged === true) {
    // Ensure redirection to home page if the user is logged
    return <Navigate to={'/home'} />
  }

  return <Outlet />
}
